module.exports = "<div class=\"slice-overlay\"></div>\n<ng-content></ng-content>"